import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { IconButton,  Card, Stack, Grid,   CssBaseline, Menu,  ListItemText,  Button, Box, useTheme, Typography, Divider, CardContent } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Modal, Checkbox, ListItemIcon } from "@mui/material";
import Header from '../../../Layout/Header';
import {
   MenuItem
} from '@mui/material';

import { CardMedia, CardActions } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';

import useAutocompleteData from '../../commonapicall//useAutocompleteData';

import Addicon1 from '@mui/icons-material/AddCircle';
import LinearProgress from '@mui/material/LinearProgress';

import { tokens } from "../../../theme/theme";

import ImageSearchIcon from '@mui/icons-material/ImageSearch';

import Tooltip from '@mui/material/Tooltip';

import CustomSnackbar from '../../../components/CustomSnackbar';

import { API_ENDPOINTS } from '../../../config/api/apiCall';


import { AppBar, Toolbar, } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import NewProductGroupDialog from './NewProductGroupDialog';
import NewProductSubGroupDialog from './NewProductSubGroupDialog';
import NewProductVarietyDialog from './NewProductVarietyDialog';
import NewDepartmentDialog from './NewDepartmentDialog';
import { useNavigate } from "react-router-dom";


import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';

import Searchicon from '@mui/icons-material/Search';

import InputAdornment from '@mui/material/InputAdornment';



const ProductMaster = ({ closePopup, onSubmit, rows, defaultValue }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const [Pricelistid, setPriceList] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');
    const [image, setImage] = useState(null);
    const [editPartyID, setEditPartyID] = useState(0)
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [selectedRows, setSelectedRows] = useState([]);
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openFirst = Boolean(anchorElFirst);
    const openSecond = Boolean(anchorElSecond);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Items');
    const [newVendor, setNewVendor] = useState(false);
    const [vendorHome, setVendorHome] = useState(true);
    const [open, setOpen] = useState(false);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);

    const navigate = useNavigate();

    const handleBackDashboard = () => {
         navigate("/");
    }



    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const result = event.target.result;
                setImage(result);

                const base64String = result.split(',')[1];
                const binaryString = window.atob(base64String);
                const byteArray = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    byteArray[i] = binaryString.charCodeAt(i);
                }

                setFormState((prevState) => ({
                    ...prevState,
                    productimage: Array.from(byteArray), // Convert Uint8Array to regular array
                }));
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    const handleImageDelete = () => {
        setImage(null);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    const showSnackbar = () => {
        setSnackbarOpen(true);
    };

    let masterGroup = '';

    let [FinancierYear, setFinancierYear] = useState(1);

    let commonParams = {
        FinancierYear,
        masterGroup,
    };

    const [selectedProductgroup, setSelectedProductgroup] = useState('');
    const [selectedProductsubgroup, setSelectedProductsubgroup] = useState('');
    const [selectedvariety, setSelectedvariety] = useState('');
    const [selectedgrade, setSelectedgrade] = useState('');
    const [selectedgrain, setSelectedgrain] = useState('');
    const [selectedunit, setselectedunit] = useState('');

    const [selectedDepartment, setSelectedDepartment] = useState('');

    const [optionsProductSubgroup, setOptionsProductSubgroup] = useState([]);
    const [optionsVariety, setOptionsVariety] = useState([]);

    //validation declaration
    const [ItemNameError, setItemNameError] = useState("");
    const [ItemError, setItemError] = useState("");
    const [GSMError, setGSMError] = useState("");

    const [WidthError, setWidthError] = useState("");
    const [GradeError, setGradeError] = useState("");
    const [ProductGroupError, setProductGroupError] = useState("");
    const [DepartmentError, setDepartmentError] = useState("");
    const [ProductSubGroupError, setProductSubGroupError] = useState("");
    const [ProductVarietyError, setProductVarietyError] = useState("");

    const [UOMError, setUOMError] = useState("");
    const [CurrencyError, setCurrencyError] = useState("");
    const [userInteracted, setUserInteracted] = useState(false);
    const [userInteractedExistingItem, setuserInteractedExistingItem] = useState(false);
    const [pageTitle, SetpageTitle] = useState('New Product');

    // const [Itemcode, setItemcode] = useState("[Auto]");
    const [disabledItemcode, setdisabledItemcode] = useState(true);
    const [disabledItemcodeSeries, setdisabledItemcodeSeries] = useState(false);
    const [visibleFinishedGoodAttributes, setvisibleFinishedGoodAttributes] = useState(false);
    const [visibleOtherGroupAttributes, setvisibleOtherGroupAttributes] = useState(false);
    const [Visibleqrcode, setVisibleqrcode] = useState(false);

    const handleClickQRCode = (e) => {
        if (!Visibleqrcode) {
            setVisibleqrcode(true);
        }
        else {
            setVisibleqrcode(false);
        }
    }

    const handleChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value,
        });
        setuserInteractedExistingItem(true);
    };

    const fetchData = async (masterGroup, filterCode, setOptionsCallback) => {
        const commonParams = {
            FinancierYear,
            masterGroup,
            filterCode,
        };

        try {
            const response = await fetch(API_ENDPOINTS.GET_MASTER_LIST_BY_CODE, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(commonParams)
            });
            if (!response.ok) {
                throw new Error(`Unable to fetch data for ${masterGroup}`);
            }
            const data = await response.json();
            if(data.length > 0) {
                setOptionsCallback(data);
            }
            else{
                setOptionsCallback([]);
            }
            
            return data;
        } catch (error) {
            throw error; // Rethrow the error to allow further handling
        }
    };

    const handleSelectDepartment = (event, newValue) => {
        if (newValue) {
            setSelectedDepartment(newValue);
            setFormState(prevState => ({
                ...prevState,
                DepartmentID: newValue.CodeId,
            }));
        }
    };


    const handleSelectProductgroup = (event, newValue) => {
        if (newValue && newValue.Description !== 'New Product Group') {
            setSelectedProductgroup(newValue);
            setFormState(prevState => ({
                ...prevState,
                ProductGroupID: newValue.CodeId,

            }));

            setFormState(prevState => ({
                ...prevState,
                ProductGroupDesc: newValue.Description,
            }));


            if (newValue.Description === 'FINISHED GOODS') {
                setvisibleFinishedGoodAttributes(true);
                setvisibleOtherGroupAttributes(false);
            }
            else {
                setvisibleFinishedGoodAttributes(false);
                setvisibleOtherGroupAttributes(true);
            }

            setNewProductSubGroup(prevState => ({
                ...prevState,
                PGroupId: newValue.CodeId,
            }));

            setnewProductVariety(prevState => ({
                ...prevState,
                PGroupId: newValue.CodeId,
            }));

            // Fetch the subgroups based on the selected product group
            return fetchData('PRODUCT_SUBGROUP', newValue.CodeId, setOptionsProductSubgroup)
                .then(data => {

                    if(data.length > 0) {
                        setSelectedProductsubgroup('');
                        setOptionsProductSubgroup(data);
    
                        setnewProductVariety(prevState => ({
                            ...prevState,
                            PGroupId: newValue.CodeId,
                            PSubGroupId: data[0].CodeId,
                        }));

                        setFormState(prevState => ({
                            ...prevState,
                            ProductSubGroup: data[0].Description,
                        }));
            
                    }                                      
                                

                    return data;
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
    };

    const handleSelectProductsubgroup = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedProductsubgroup(newValue);
            setFormState(prevState => ({
                ...prevState,
                ProductSubGroupID: newValue.CodeId,
            }));
            setnewProductVariety(prevState => ({
                ...prevState,
                PSubGroupId: newValue.CodeId,
            }));

            setFormState(prevState => ({
                ...prevState,
                ProductSubGroup: newValue.Description,
            }));

            return fetchData('PRODUCT_VARIETY', newValue.CodeId, setOptionsVariety)
                .then(data => {
                    setSelectedvariety('');
                    return data;
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
    };

    const handleSelectvariety = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedvariety(newValue);
            setFormState(prevState => ({
                ...prevState,
                VARIETY: newValue.Description,
                ProductVarietyID: newValue.CodeId,
            }));

            setFormState(prevState => ({
                ...prevState,
                ProductVariety: newValue.Description,
            }));
        }
    };

    const handleSelectgrade = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedgrade(newValue);
            setFormState(prevState => ({
                ...prevState,
                GRADE: newValue.CodeId,
            }));
            setUserInteracted(true);
        }
    };



    const handleSelectunit = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setselectedunit(newValue);
            setFormState(prevState => ({
                ...prevState,
                unit: newValue.Description,
            }));
        }
    };

    const handleCurrencyChange = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setCurrency(newValue);
            setFormState(prevState => ({
                ...prevState,
                currencyID: newValue.CodeId,
            }));
        }
    };

    const dataProductDepartment = useAutocompleteData(
        API_ENDPOINTS.GET_MASTER_LIST,
        {
            ...commonParams,
            masterGroup: 'PRODUCT_DEPARTMENT',
        }
    );

    const dataProductgroup = useAutocompleteData(
        API_ENDPOINTS.GET_MASTER_LIST,
        {
            ...commonParams,
            masterGroup: 'PRODUCT_GROUP',
        }
    );

    const dataGrade = useAutocompleteData(
        API_ENDPOINTS.GET_MASTER_LIST_BY_CODE,
        {
            ...commonParams,
            masterGroup: 'ITEM_GRADE',
            filterCode: 'Select Grade',
        }
    );



    const datagrain = useAutocompleteData(
        API_ENDPOINTS.GET_MASTER_LIST_BY_CODE,
        {
            ...commonParams,
            masterGroup: 'ITEM_GRAIN',
            filterCode: 'Select Grain Direction',
        }
    );

    const dataUnit = useAutocompleteData(
        API_ENDPOINTS.GET_MASTER_LIST_BY_CODE,
        {
            ...commonParams,
            masterGroup: 'ITEM_UNIT',
            filterCode: 'Select Unit'
        }
    );

    const data_currency = useAutocompleteData(
        API_ENDPOINTS.GET_MASTER_LIST_BY_CODE,
        {
            ...commonParams,
            masterGroup: 'CURRENCY',
            filterCode: 'Select CURRENCY'
        }
    );

 






    const getDefaultFormValues = (defaultValue) => {
        if (defaultValue) {
            return defaultValue;
        }
        else {
            return {
                id: 0,
                ProductGroupID: 0,
                ProductGroupDesc: '',
                ProductSubGroup: '',
                ProductVariety: '',
                ProductSubGroupID: 0,
                ProductVarietyID: 0,
                Code: '[Auto]',
                Name: '',
                CodeSeries: 'Auto',
                AuthorisedForSaleFlag: 'True',
                Color: 'White',
                GRADE: '',
                GSM: 0,
                BF: 0,
                WIDTH: 0,
                LENGTH: 0,
                Thickness: 0,
                MinLevel: 0,
                MaxLevel: 0,
                OpeningQty: 0,
                OpeningQtyValue: 0,
                ReOrderLevel: 0,
                ShelfLifeDays: 0,
                UnitOfMeasureCode: 'kgs',
                unit: 'cm',
                HSNCode: 48109200,
                DiscountFlag: 'True',
                AllowNegativeInventoryFlag: 'False',
                DiscountType: '',
                DiscountRate: 0,
                TaxInclusiveSalePrice: 0,
                TaxExemptedFlag: 'True',
                MinimumSaleQty: 0,
                MaximumSaleQty: 0,
                RequestedQty: 0,
                UNITPRICE: 0,
                VARIETY: '',
                GRAIN: '',
                REELOD: 0,
                COREID: 0,
                NOOFSHEETS: 0,
                ReamWeight: 0,
                ORDERQTY: 0,
                COQTY: 0,
                REMARKS: '',
                SPECIAL_INSTRUCTION: '',
                OrderType: '',
                STATUS: '',
                PriceListId: '',
                ProductID: 0,
                SProductID: 0,
                SICode: '',
                SIVariety: '',
                SIGSM: 0,
                SIWidth: 0,
                SILength: 0,
                SIColor: '',
                SIGrainDirection: '',
                SIPackageMode: '',
                SIRequested_Qty: 0,
                SIConfirmed_Qty: 0,
                SINoOfSheets: 0,
                SIReamWeight: 0,
                SIUnitPrice: 0,
                SIDiscountType: '',
                SIDiscount: 0,
                SIReelCoreID: 0,
                SIReelOD: 0,
                SIRemarks: '',
                SISpecialInstruction: '',
                SIOrderType: '',
                DMStatus: '',
                ProductType: '',
                DepartmentID: 0,
                currencyID: 0,
                QRReference: '',
                QRType: '',
                QR: '',
                productimage: '',

            };
        }
    };

    const [formState, setFormState] = useState(getDefaultFormValues(defaultValue));

    useEffect(() => {
        if (userInteracted === false) {
            if (data_currency.length > 0) {
                for (let i = 0; i < data_currency.length; i++) {
                    const returnValue = data_currency[i];
                    if (returnValue.Description === 'INR') {
                        setCurrency(returnValue);
                        setFormState(prevState => ({
                            ...prevState,
                            currencyID: data_currency[i].CodeId,
                        }));
                        setUserInteracted(true);
                        break;  // Exit the loop after the first non-empty value is found
                    }
                }
            }


            if (formState.RequestedQty > 0 && formState.COQTY <= 0) {
                setFormState(prevState => ({
                    ...prevState,
                    COQTY: formState.RequestedQty,
                }));
            }
        }

        //If sub group only single value set as default value.//
        if (optionsProductSubgroup.length > 0 && optionsProductSubgroup.length <= 1) {
            setSelectedProductsubgroup(optionsProductSubgroup[0]);
            setFormState(prevState => ({
                ...prevState,
                ProductSubGroupID: optionsProductSubgroup[0].CodeId,
            }));
            fetchData('PRODUCT_VARIETY', optionsProductSubgroup[0].CodeId, setOptionsVariety);
        }

        if (datagrain.length > 0) {
            let grainValue = 'B';

            if (formState.WIDTH > formState.LENGTH) {
                grainValue = 'S';
            }

            if (formState.WIDTH < formState.LENGTH) {
                grainValue = 'L';
            }

            for (let i = 0; i < datagrain.length; i++) {
                const returnValue = datagrain[i].CodeId;
                if (returnValue === grainValue) {
                    setSelectedgrain(datagrain[i]);
                    break;  // Exit the loop after the first non-empty value is found
                }
            }
        }

        //Exiting Items
        if (defaultValue != null && userInteractedExistingItem === false) {
            SetpageTitle('Update Product Detail');

            formState.WIDTH = defaultValue.SIWidth;
            formState.LENGTH = defaultValue.SILength;
            formState.REELOD = defaultValue.SIReelOD;
            formState.COREID = defaultValue.SIReelCoreID;
            formState.NOOFSHEETS = defaultValue.SINoOfSheets;
            formState.RequestedQty = defaultValue.SIRequested_Qty;
            formState.COQTY = defaultValue.SIConfirmed_Qty;
            formState.UNITPRICE = defaultValue.SIUnitPrice;
            formState.SPECIAL_INSTRUCTION = defaultValue.SISpecialInstruction;
            formState.GSM = defaultValue.SIGSM
            formState.SProductID = defaultValue.SProductID;
            formState.SICode = defaultValue.SICode;

            if (dataProductgroup.length > 0) {
                const codeIdValue = defaultValue.ProductGroupID;
                const stringCodeIdValue = String(codeIdValue);
                const filteredData = dataProductgroup.filter((item) => item.CodeId === stringCodeIdValue);

                if (filteredData.length > 0) {
                    setSelectedProductgroup(filteredData[0]);
                    handleSelectProductgroup(0, filteredData[0])
                }
            }

            if (optionsProductSubgroup.length > 0) {
                const codeIdValue = defaultValue.ProductSubGroupID;
                const stringCodeIdValue = String(codeIdValue);
                const filteredData = optionsProductSubgroup.filter((item) => item.CodeId === stringCodeIdValue);

                if (filteredData.length > 0) {
                    setSelectedProductsubgroup(filteredData[0]);
                    handleSelectProductsubgroup(0, filteredData[0])
                }
            }

            if (optionsVariety.length > 0) {
                const codeIdValue = defaultValue.ProductVarietyID;
                const stringCodeIdValue = String(codeIdValue);
                const filteredData = optionsVariety.filter((item) => item.CodeId === stringCodeIdValue);

                if (filteredData.length > 0) {
                    setSelectedvariety(filteredData[0]);
                    setFormState(prevState => ({
                        ...prevState,
                        VARIETY: filteredData[0].Description,
                        ProductVarietyID: filteredData[0].CodeId,
                    }));
                }
            }
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        formState.PriceListId = Pricelistid;
        let formDirty = false;

        const validateField = (field, errorSetter, errorMessage) => {
            if (!formState[field] || !formState[field].length || formState[field] === 0) {
                errorSetter(errorMessage);
                return true;
            }
            errorSetter("");
            return false;
        };

        const validateNumberField = (field, errorSetter, errorMessage) => {
            if (formState[field] === 0) {
                errorSetter(errorMessage);
                return true;
            }
            errorSetter("");
            return false;
        };

        formDirty = validateField("ProductGroupID", setProductGroupError, "Product Group is required") || formDirty;
        formDirty = validateField("ProductSubGroupID", setProductSubGroupError, "Product Sub Group is required") || formDirty;
        formDirty = validateField("ProductVarietyID", setProductVarietyError, "Product Variety is required") || formDirty;

        if (formState.Code === '' && disabledItemcode === false) {
            formDirty = validateField("Code", setItemError, "Item code is required") || formDirty;
        }

        if (formState.thickness === null) {
            formState.thickness = 0;
        }

        if (selectedProductgroup.Description === 'FINISHED GOODS') {
            formDirty = validateNumberField("GSM", setGSMError, "GSM is required") || formDirty;
            formDirty = validateNumberField("WIDTH", setWidthError, "Width is required") || formDirty;
            formDirty = validateField("GRADE", setGradeError, "Grade is required") || formDirty;
            formDirty = validateField("unit", setUOMError, "UOM is required") || formDirty;
        }
        else {
            formDirty = validateField("DepartmentID", setDepartmentError, "Product Department is required") || formDirty;
            formDirty = validateField("Name", setItemNameError, "Product Name is required") || formDirty;
        }

        if (!formDirty) {
            fetch(API_ENDPOINTS.Promaster_getProductDetails, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formState)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to add product item in the order');
                    }
                    return response.json();
                })
                .then(data => {
                    console.log('new product created');

                    if (data.returnMessage !== '') {
                        showError(data.returnMessage, 'warning');
                    }
                    else {
                        showError('New Product Created Successfully..!', 'success');
                        LoadProductList();
                        setisVisible_ProductList(true);
                        setisVisible_ProductAddEdit(false);
                        setisVisible_commanButtons(false);
                    }

                })
                .catch(error => {
                    setAlertMessage('Unable to add product items in the order..!');
                    setalertsevierity('error');
                    showSnackbar();
                }, []);
        }
    };


    const [isVisible_ProductList, setisVisible_ProductList] = useState(true);
    const [isVisible_ProductAddEdit, setisVisible_ProductAddEdit] = useState(false);
    const [rows1, setTableData1] = useState([]);


    const handleCreateProduct = (e) => {
        e.preventDefault();
        setisVisible_ProductList(false);
        setisVisible_ProductAddEdit(true);
        setisVisible_commanButtons(true);
        ClearAll();
        SetpageTitle('New Product');
        setdisabledItemcodeSeries(false);
    }
    const handleCloseProductAddEdit = (e) => {
        // e.preventDefault();
        setisVisible_ProductList(true);
        setisVisible_ProductAddEdit(false);
        setisVisible_commanButtons(false);
    }
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
    const [loading, setLoading] = React.useState(false);

    let [CompanyID] = useState(1);

    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };

    const LoadProductList = (e) => {
        setLoading(true); // Set loading state to true before fetching data

        const ConstructedGlobalValues = {
            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
            COMPANY_ID: CompanyID,
        };

        fetch(API_ENDPOINTS.GetProductList, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(ConstructedGlobalValues)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load product details');
                }
                return response.json();
            })
            .then(data => {
                const formattedData = data.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setTableData1(formattedData);
            })
            .catch(error => {
                showError('Unable to load the product details', 'error');
            })
            .finally(() => {
                setLoading(false); // Set loading state to false after fetching data
            });
    };

    useEffect(() => {
        LoadProductList();
    }, []);


   

    let isFetching = false;

    const handleOnCellClick = async (params, event) => {
        if (isFetching) return;  // Prevent concurrent request

        isFetching = true;
        console.log('Handling cell click:', params);
        ClearAll();

        const productid = params.ProductID;
        const group = params.ProductGroup;
        const requestBody = {
            ProductId: productid,
            filter: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: CompanyID,
            }
        };

        try {
            const apiEndpoint = group === 'FINISHED GOODS'
                ? API_ENDPOINTS.GetProductData
                : API_ENDPOINTS.GetProductDataAll;

            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody),
                timeout: 10  // Set timeout to 10 seconds
            });

            if (!response.ok) {
                const errorMessage = await response.text();
                throw new Error(`Unable to load product details properly.! Server responded with: ${errorMessage}`);
            }

            const data = await response.json();



            if (data && data.length > 0) {
                const productGroupData = data[0];

                if (dataProductgroup && dataProductgroup.length > 0) {
                    const codeIdValue = String(productGroupData.ProductGroupID);
                    const filteredProductGroup = dataProductgroup.find(item => item.CodeId === codeIdValue);

                    if (filteredProductGroup) {
                        setSelectedProductgroup(filteredProductGroup);
                        setFormState(prevState => ({
                            ...prevState,
                            ProductGroupID: filteredProductGroup.CodeId,
                        }));

                        const productSubgroupData = await handleSelectProductgroup(0, filteredProductGroup);
                        if (productSubgroupData && productSubgroupData.length > 0) {
                            const subGroupCodeIdValue = String(productSubgroupData[0].CodeId);
                            const filteredProductSubgroup = productSubgroupData.find(item => item.CodeId === subGroupCodeIdValue);

                            if (filteredProductSubgroup) {
                                setSelectedProductsubgroup(filteredProductSubgroup);
                                setFormState(prevState => ({
                                    ...prevState,
                                    ProductSubGroupID: filteredProductSubgroup.CodeId,
                                }));

                                const productVarietyData = await handleSelectProductsubgroup(0, filteredProductSubgroup);
                                if (productVarietyData && productVarietyData.length > 0) {
                                    const varietyCodeIdValue = String(productGroupData.ProductVarietyID);
                                    const filteredVariety = productVarietyData.find(item => item.CodeId === varietyCodeIdValue);

                                    if (filteredVariety) {
                                        setSelectedvariety(filteredVariety);
                                        setFormState(prevState => ({
                                            ...prevState,
                                            VARIETY: filteredVariety.Description,
                                            ProductVarietyID: filteredVariety.CodeId,
                                        }));
                                    }
                                }
                            }
                        }
                    }
                }

                if (dataUnit && dataUnit.length > 0) {
                    const codeIdValue = String(productGroupData.unit);
                    const filter = dataUnit.find(item => item.CodeId === codeIdValue);

                    if (filter) {
                        setselectedunit(filter);
                        setFormState(prevState => ({
                            ...prevState,
                            unit: filter.CodeId,
                        }));
                    }
                }

                if (dataGrade && dataGrade.length > 0) {
                    const codeIdValue = String(productGroupData.Grade);
                    const filter = dataGrade.find(item => item.CodeId === codeIdValue);

                    if (filter) {
                        setSelectedgrade(filter);
                        setFormState(prevState => ({
                            ...prevState,
                            GRADE: filter.CodeId,
                        }));
                    }
                }

                setFormState(prevState => ({
                    ...prevState,
                    WIDTH: productGroupData.Width,
                    LENGTH: productGroupData.Length,
                    REELOD: productGroupData.ReelOD,
                    COREID: productGroupData.ReelCoreID,
                    NOOFSHEETS: productGroupData.NoOfSheets,
                    RequestedQty: productGroupData.Requested_Qty,
                    COQTY: productGroupData.Confirmed_Qty,
                    UNITPRICE: productGroupData.UnitPrice,
                    SPECIAL_INSTRUCTION: productGroupData.SpecialInstruction,
                    GSM: productGroupData.GSM,
                    SProductID: productGroupData.ProductID,
                    ProductID: productGroupData.ProductID,
                    SICode: productGroupData.Code,
                    Code: productGroupData.Code,
                    BF: productGroupData.BF,
                    UnitOfMeasureCode: productGroupData.UnitOfMeasureCode,
                    unit: productGroupData.unit,
                    thickness: productGroupData.thickness,
                    Name: productGroupData.Name,
                    QRReference: productGroupData.QRReference,
                    QRType: productGroupData.QRType,
                    QR: productGroupData.QR,
                    ProductImage: productGroupData.ProductImage
                }));

                const base64Image = productGroupData.ProductImage_converted; // Assuming your API response has imageBase64 field
                setImage(`data:image/png;base64,${base64Image}`);

                if (dataProductDepartment && dataProductDepartment.length > 0) {
                    const codeIdValue = String(productGroupData.DepartmentID);
                    const filteredProductGroup = dataProductDepartment.find(item => item.CodeId === codeIdValue);

                    if (filteredProductGroup) {
                        setSelectedDepartment(filteredProductGroup);
                        setFormState(prevState => ({
                            ...prevState,
                            DepartmentID: filteredProductGroup.CodeId,
                        }));
                    }
                }

                if (group !== 'FINISHED GOODS' && data_currency && data_currency.length > 0) {
                    const codeIdValue = String(productGroupData.currencyID);
                    const filteredProductGroup = data_currency.find(item => item.CodeId === codeIdValue);

                    if (filteredProductGroup) {
                        setCurrency(filteredProductGroup);
                        setFormState(prevState => ({
                            ...prevState,
                            currencyID: filteredProductGroup.CodeId,
                        }));
                    }
                }

                setPrice(productGroupData.UnitPrice);
                SetpageTitle('Edit Product');
                setisVisible_ProductList(false);
                setisVisible_ProductAddEdit(true);
                setisVisible_commanButtons(true);
                setdisabledItemcodeSeries(true);
            } else {

                showError('No data found.', 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            showError('Unable to load product details properly.!' + error, 'error');
        }
    };


  
    const [isVisible_commanButtons, setisVisible_commanButtons] = useState(false);

    const [value, setValue] = React.useState('Auto');



  
 

    const ClearAll = async () => {
        // Assuming you might have asynchronous operations in the future
        try {
            // Reset formState to its default values
            setFormState(getDefaultFormValues(null));

            // Clear other states and form fields
            setImage(null);
            setSelectedDepartment([]);
            setSelectedProductsubgroup([]);
            setSelectedProductgroup([]);
            setSelectedvariety([]);
            setValue('Auto');
            setselectedunit('');
            setGSMError('');
            setWidthError('');
            setGradeError('');
            setProductGroupError('');
            setProductSubGroupError('');
            setProductVarietyError('');
            setUOMError('');
            setdisabledItemcodeSeries(false);
            SetpageTitle('New Product');
            setvisibleFinishedGoodAttributes(false);
            setvisibleOtherGroupAttributes(false);
            setPrice('');

            // If you have any asynchronous operations, await them here
            // Example:
            // await someAsyncOperation();

        } catch (error) {
            console.error('Error during ClearAll:', error);
            showError('Failed to clear all fields properly!', 'error');
        }
    };


 

    const [openDialog, setOpenDialog] = useState(false);
    const [openDialog_subGroup, setOpenDialog_subGroup] = useState(false);
    const [openDialog_variety, setopenDialog_variety] = useState(false);
    const [openDialog_department, setopenDialog_department] = useState(false);

    const [newDepartment, setNewDepartment] = useState({
        DepartmentCode: '',
        DepartmentCodeDesc: '',
        DepartmentCodeStatus: 'A',
    });

    const [newProductGroup, setNewProductGroup] = useState({
        PGroupCode: '',
        PGroupDesc: '',
        PGroupStatus: 'A',
    });

    const [newProductSubGroup, setNewProductSubGroup] = useState({
        PSubGroupCode: '',
        PSubGroupDesc: '',
        PSubGroupStatus: 'A',
        PGroupId: 0,
    });

    const [newProductVariety, setnewProductVariety] = useState({
        PVarietyCode: '',
        PVarietyDesc: '',
        PVarietyStatus: 'A',
        PGroupId: 0,
        PSubGroupId: 0,
    });


    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleOpenDialog_Department = () => {
        setopenDialog_department(true);
    };

    const handleOpenDialogSubGroup = () => {
        setOpenDialog_subGroup(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCloseDialog_Department = () => {
        setopenDialog_department(false);
    };

    const handleCloseDialogSubGroup = () => {
        setOpenDialog_subGroup(false);
    };

    const handleCloseDialogvariety = () => {
        setopenDialog_variety(false);
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewProductGroup({
            ...newProductGroup,
            [name]: value,
        });
    };
    const handleInputChangeForDepartment = (event) => {
        const { name, value } = event.target;
        setNewDepartment(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleInputChangeForSubGroup = (event) => {
        const { name, value } = event.target;
        setNewProductSubGroup(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleInputChangeForvariety = (event) => {
        const { name, value } = event.target;
        setnewProductVariety(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleAddDepartment = () => {
        // Add your logic to save the new product group
        if (!newDepartment.DepartmentCode || !newDepartment.DepartmentCodeDesc) {
            // If either field is empty, do not proceed
            return;
        }

        const clsproductDet = {
            cls: newDepartment,
        };

        fetch(API_ENDPOINTS.AddOrUpdateProductDepartment, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(clsproductDet)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to add product department');
                }
                return response.json();
            })
            .then(data => {
                showError(data.returnmsg, 'success');
            })
            .catch(error => {
                setAlertMessage('Unable to add product department..!');
                setalertsevierity('error');
                showSnackbar();
            }, []);


        handleCloseDialog_Department();
    };

    const handleAddProductGroup = () => {
        // Add your logic to save the new product group
        if (!newProductGroup.PGroupCode || !newProductGroup.PGroupDesc) {
            // If either field is empty, do not proceed
            return;
        }

        const clsproductDet = {
            clsPGroup: newProductGroup,
        };

        fetch(API_ENDPOINTS.AddOrUpdateProductGroup, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(clsproductDet)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to add product group');
                }
                return response.json();
            })
            .then(data => {
                showError(data.returnmsg, 'success');
            })
            .catch(error => {
                setAlertMessage('Unable to add product group..!');
                setalertsevierity('error');
                showSnackbar();
            }, []);

        console.log('New Product Group:', newProductGroup);
        handleCloseDialog();
    };

    const handleAddProductSubGroup = () => {
        if (newProductSubGroup.PGroupId === 0 || !newProductSubGroup.PSubGroupCode || !newProductSubGroup.PSubGroupDesc || !newProductSubGroup.PSubGroupStatus) {
            // If either field is empty, do not proceed
            return;
        }
        const clsproductDet = {
            clsPSubGroup: newProductSubGroup,
        };
        fetch(API_ENDPOINTS.AddOrUpdateProductSubGroup, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(clsproductDet)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to add product sub group');
                }
                return response.json();
            })
            .then(data => {
                showError(data.returnmsg, 'success');

                fetchData('PRODUCT_SUBGROUP', newProductSubGroup.PGroupId, setOptionsProductSubgroup)
                    .then(data => {
                        setSelectedProductsubgroup('');
                        setOptionsProductSubgroup(data);
                    })
                    .catch(error => {
                        console.error('Error fetching data:', error);
                    });
            })
            .catch(error => {
                setAlertMessage('Unable to add product sub group..!');
                setalertsevierity('error');
                showSnackbar();
            }, []);

        handleClearFormForSubGroup();
    };

    const handleAddProductvariety = () => {
        if (newProductVariety.PGroupId === 0 | newProductVariety.PSubGroupId === 0 | !newProductVariety.PVarietyCode || !newProductVariety.PVarietyDesc || !newProductVariety.PVarietyStatus) {
            // If either field is empty, do not proceed
            return;
        }
        const clsproductDet = {
            clsVariety: newProductVariety,
        };
        fetch(API_ENDPOINTS.AddOrUpdateProductVariety, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(clsproductDet)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to add product variety');
                }
                return response.json();
            })
            .then(data => {
                showError(data.returnmsg, 'success');

                return fetchData('PRODUCT_VARIETY', newProductVariety.PSubGroupId, setOptionsVariety)
                    .then(data => {
                        return data;
                    })
                    .catch(error => {
                        console.error('Error fetching data:', error);
                    });
            })
            .catch(error => {
                setAlertMessage('Unable to add product variety.!');
                setalertsevierity('error');
                showSnackbar();
            }, []);

        handleClearFormVariety();
    };

    const handleClearForm = () => {
        setNewProductGroup({
            PGroupCode: '',
            PGroupDesc: '',
            PGroupStatus: '',
        });
    };

    const handleClearFormForDepartment = () => {
        setNewDepartment({
            DepartmentCode: '',
            DepartmentCodeDesc: '',
            DepartmentCodeStatus: 'A',
        });
    };
    const handleClearFormForSubGroup = () => {
        setNewProductSubGroup({
            PGroupId: 0,
            PSubGroupCode: '',
            PSubGroupDesc: '',
            PSubGroupStatus: '',
        });
    };

    const handleClearFormVariety = () => {
        setnewProductVariety({
            PGroupId: 0,
            PSubGroupId: 0,
            PVarietyCode: '',
            PVarietyDesc: '',
            PVarietyStatus: '',
        });
    };

    const [currency, setCurrency] = useState('');
    const [price, setPrice] = useState('');


    const handlePriceChange = (event) => {
        setPrice(event.target.value);

        setFormState(prevState => ({
            ...prevState,
            UNITPRICE: event.target.value,
        }));
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result.split(',')[1];
            const binaryString = window.atob(base64String);
            const byteArray = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                byteArray[i] = binaryString.charCodeAt(i);
            }

            setFormState({
                ...formState,
                QR: Array.from(byteArray) // Convert Uint8Array to regular array
            });
        };
        reader.readAsDataURL(file);
    };



    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;
    const [filters, setFilters] = useState({
        ProductGroup: '',
        ProductSubGroup: '',
        ProductVariety: '',
        Code: '',
        Name: '',

    });

    const filteredData = rows1.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.ProductGroup === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = rows1.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);


    };

    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };
    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        setSelectedStatus(option);

        // if (option === 'FINISHED GOODS') {
        //     setSelectedStatus('FINISHED GOODS');
        // }
        // else if (option === 'RAW MATERIAL') {
        //     setSelectedStatus('RAW MATERIAL');
        // }

        if (option === 'All Items') {
            setSelectedStatus('All');
        }

        setAnchorElFirst(null);
    };



    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };


    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        }
        else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const handleCallEdit = (value) => {
        setEditPartyID(value);
        setVendorHome(false);
        setNewVendor(true);

        //const newSelectedRows = rows1.map((row) => row.id);
        handleOnCellClick(value)
    };

    const fileInputRef = useRef(null);

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null; // Reset the input value
            fileInputRef.current.click();
        }
    };


    return (
        <Box component="form" autoComplete="off" style={{ width: '100%' }}>
            <CustomSnackbar
                open={snackbarOpen}
                message={alertMessage}
                onClose={handleSnackbarClose}
                type={alertsevierity}
            />

            {loading && (
                <Box sx={{ width: '100%', marginTop: '10px' }}>
                    <LinearProgress
                        variant="buffer"
                        sx={{
                            '& .MuiLinearProgress-barColorPrimary': {
                                backgroundColor: '#4CAF50', // Green color (you can replace this with your desired color)
                            },
                            '& .MuiLinearProgress-bar2Buffer': {
                                backgroundColor: '#8BC34A', // Another shade of green for the buffer
                            },
                        }}
                        value={progress}
                        valueBuffer={buffer}
                    />
                </Box>
            )}

            <CssBaseline />
            {isVisible_ProductList && (
                <AppBar position="static" sx={{ backgroundColor: "inherit" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="inherit"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal" }} />}
                            sx={{ textTransform: 'none', fontSize: "25px", fontWeight: "semi bold" }}
                        >
                            {selectedOptionFirst}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}
                        >
                            <MenuItem onClick={() => handleMenuItemClickFirst('All Items')}>All Items</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('FINISHED GOODS')}>Finished Goods</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('RAW MATERIAL')}>Raw Material</MenuItem>
                
                        </Menu>

                        {/* Adding margin-left: auto to push the button to the right */}
                        <Button size="small" variant="contained" onClick={handleCreateProduct} color="secondary" startIcon={<AddIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ ml: 2 }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Items')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Items" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Items')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Items" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                {/* <ListItemIcon>
                                    <FormatAlignJustifyIcon />
                                </ListItemIcon>
                                <ListItemText primary="Reset Column Width" /> */}
                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleMenuClickSecond}
                        >
                            <HelpIcon />
                        </IconButton>

                        <div>
                            <IconButton>
                                <Close fontSize="inherit" style={{ color: "#2196F3" }} onClick={handleBackDashboard} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>
            )}

            {isVisible_ProductList && (
                <Box
                    gridColumn="span 9"
                    gridRow={"span 2"}
                    alignItems="center"
                    justifyContent="center"
                    padding={1}
                    sx={{
                        "& .MuiTable-root": {
                            border: "none",
                            size: "small",
                        },
                        "& .MuiTableCell-root": {
                            borderBottom: "none",
                            // fontWeight: "bold",
                            border: "1px solid ",
                            borderColor: `${colors.primary[400]} !important`,
                        },
                        "& .name-column--cell": {
                            color: colors.greenAccent[300],
                        },
                        "& .MuiTableHead-root": {
                            // backgroundColor: colors.blueAccent[700],
                            borderBottom: "none",
                        },
                        "& .MuiTableBody-root": {
                            overflowY: "auto",
                        },
                        "& .MuiCheckbox-root": {
                            color: `${colors.blueAccent[200]} !important`,
                            size: "small",
                        },
                        "& .MuiTableFooter-root": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[700],
                            height: "10px",
                        },
                        "& .MuiButton-text": {
                            color: `${colors.grey[100]} !important`,
                        },
                    }}>

                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    <TableCell>
                                        <Checkbox size="small" style={{ color: "secondary" }}
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                            checked={selectedRows.length === filteredData.length}
                                            onChange={handleSelectAllClick}
                                        />
                                    </TableCell>
                                    <TableCell>CODE</TableCell>
                                    <TableCell>NAME</TableCell>
                                    <TableCell>GROUP</TableCell>
                                    <TableCell>SUB GROUP</TableCell>
                                    <TableCell>VARIETY</TableCell>
                                    {/* <TableCell>REORDER LEVEL</TableCell>
                                    <TableCell>STATUS</TableCell> */}
                                    {/* <TableCell>PAYALES</TableCell> */}
                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                <TextField
                                                    label="Group"
                                                    name="ProductGroup"
                                                    value={filters.ProductGroup}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"

                                                />
                                                <TextField
                                                    label="Sub Group"
                                                    name="ProductSubGroup"
                                                    value={filters.ProductSubGroup}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Variety"
                                                    name="ProductVariety"
                                                    value={filters.ProductVariety}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Code"
                                                    name="Code"
                                                    value={filters.Code}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Name"
                                                    name="Name"
                                                    value={filters.Name}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row) => (
                                    <TableRow key={row.ProductID}>
                                        <TableCell>
                                            <Checkbox
                                                size="small"
                                                checked={isSelected(row.ProductID)}
                                                onChange={(event) => handleRowCheckboxClick(event, row.ProductID)}
                                            />
                                        </TableCell>
                                        {/* <TableCell>{row.name}</TableCell> */}
                                        <TableCell>
                                            <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleCallEdit(row)}
                                            >
                                                {row.Code}
                                            </span>
                                        </TableCell>
                                        <TableCell>{row.Name}</TableCell>
                                        <TableCell>{row.ProductGroup}</TableCell>
                                        <TableCell>{row.ProductSubGroup}</TableCell>
                                        <TableCell>{row.ProductVariety}</TableCell>
                                        {/* <TableCell>{row.payales}</TableCell> */}

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            )}         


            {isVisible_ProductAddEdit && (
                <Box >


                    <Header title={pageTitle} subtitle="" callback={handleCloseProductAddEdit} />
                    <Divider />


                    <Box
                        sx={{
                            // backgroundColor: colors.primary[700],
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '74vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        <CardContent>
                            <Grid container spacing={0}>

                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} mr={2}>



                                    <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                        <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Code
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={6} xl={6}>
                                            <TextField
                                                size='small' variant="outlined"
                                                error={ItemError && ItemError.length ? true : false}
                                                required
                                                helperText={ItemError}
                                                fullWidth
                                                disabled={disabledItemcode}
                                                onChange={handleChange}
                                                value={formState.Code}
                                                name='Code'
                                            />
                                        </Grid>
                                    </Grid>



                                    <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '5px' }}>
                                        <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Department
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={7} xl={7}>
                                            <Autocomplete
                                                size="small"
                                                required
                                                value={selectedDepartment}
                                                onChange={handleSelectDepartment}
                                                options={dataProductDepartment}
                                                getOptionLabel={(option) => option.Description || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Department"
                                                        error={DepartmentError && DepartmentError.length ? true : false}
                                                        required
                                                        variant="outlined"
                                                        helperText={DepartmentError}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={1} xl={1}>
                                            <Tooltip title="Add New Department" arrow className="MuiTooltip-tooltip">
                                                <IconButton onClick={handleOpenDialog_Department}>
                                                    <Addicon1 sx={{ color: '#298af2' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>

                                        <NewDepartmentDialog
                                            open={openDialog_department}
                                            onClose={handleCloseDialog_Department}
                                            onAdd={handleAddDepartment}
                                            onClear={handleClearFormForDepartment}
                                            newDepartment={newDepartment}
                                            handleInputChange={handleInputChangeForDepartment}
                                        />
                                    </Grid>

                                    <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '5px' }}>
                                        <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Group
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={7} xl={7}>
                                            <Autocomplete
                                                size="small"
                                                required
                                                value={selectedProductgroup}
                                                onChange={handleSelectProductgroup}
                                                options={dataProductgroup}
                                                getOptionLabel={(option) => option.Description || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Product Group"
                                                        error={ProductGroupError && ProductGroupError.length ? true : false}
                                                        required
                                                        variant="outlined"
                                                        helperText={ProductGroupError}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={1} xl={1}>
                                            <Tooltip title="Add New Group" arrow className="MuiTooltip-tooltip">
                                                <IconButton onClick={handleOpenDialog}>
                                                    <Addicon1 sx={{ color: '#298af2' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>

                                        <NewProductGroupDialog
                                            open={openDialog}
                                            onClose={handleCloseDialog}
                                            onAdd={handleAddProductGroup}
                                            onClear={handleClearForm}
                                            productGroup={newProductGroup}
                                            handleInputChange={handleInputChange}
                                        />

                                    </Grid>

                                    <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                        <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Sub Group
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={7} xl={7}>

                                            <Autocomplete
                                                id="dropdown_product_subgroup"
                                                size='small'
                                                value={selectedProductsubgroup}
                                                onChange={handleSelectProductsubgroup}
                                                options={optionsProductSubgroup}
                                                getOptionLabel={(option) => option.Description || ''}
                                                renderInput={(params) => (
                                                    <TextField {...params}
                                                        label="Product Sub Group"
                                                        variant="outlined"
                                                        error={ProductSubGroupError && ProductSubGroupError.length ? true : false}
                                                        required
                                                        helperText={ProductSubGroupError}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={1} xl={1}>
                                            <Tooltip title="Add New Sub Group" arrow className="MuiTooltip-tooltip">
                                                <IconButton onClick={handleOpenDialogSubGroup}>
                                                    <Addicon1 sx={{ color: '#298af2' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>

                                        <NewProductSubGroupDialog
                                            open={openDialog_subGroup}
                                            onClose={handleCloseDialogSubGroup}
                                            onAdd={handleAddProductSubGroup}
                                            onClear={handleClearFormForSubGroup}
                                            newProductSubGroup={newProductSubGroup}
                                            handleInputChange={handleInputChangeForSubGroup}

                                            label="Product Group"
                                            valueDDL={selectedProductgroup}
                                            onChange={handleSelectProductgroup}
                                            options={dataProductgroup}
                                            getOptionLabel={(option) => option.Description || ''}
                                            error={ProductGroupError}
                                            helperText={ProductGroupError}
                                        />
                                    </Grid>

                                    <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                        <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Variety
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={7} xl={7}>
                                            <Autocomplete
                                                id="dropdown_variety"
                                                size='small'
                                                value={selectedvariety}
                                                onChange={handleSelectvariety}
                                                options={optionsVariety}
                                                getOptionLabel={(option) => option.Description || ''}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Variety" variant="outlined"
                                                        error={ProductVarietyError && ProductVarietyError.length ? true : false}
                                                        required
                                                        helperText={ProductVarietyError} />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={1} xl={1}>
                                            <Tooltip title="Add New Variety" arrow className="MuiTooltip-tooltip">
                                                <IconButton onClick={setopenDialog_variety} sx={{ // Light background for button
                                                    color: '#298af2', // Primary color for icon
                                                }}>
                                                    <Addicon1 sx={{}} />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>




                                        <NewProductVarietyDialog
                                            open={openDialog_variety}
                                            onClose={handleCloseDialogvariety}
                                            onAdd={handleAddProductvariety}
                                            onClear={handleClearFormVariety}
                                            newProductVariety={newProductVariety}
                                            handleInputChange={handleInputChangeForvariety}

                                            valuePG={selectedProductgroup}
                                            onChange={handleSelectProductgroup}
                                            options={dataProductgroup}
                                            getOptionLabel={(option) => option.Description || ''}
                                            error={ProductGroupError}
                                            helperText={ProductGroupError}

                                            valuePSB={selectedProductsubgroup}
                                            onChange1={handleSelectProductsubgroup}
                                            options1={optionsProductSubgroup}
                                            getOptionLabel1={(option) => option.Description || ''}
                                            error1={ProductSubGroupError}
                                            helperText1={ProductSubGroupError}
                                        />
                                    </Grid>




                                    {visibleOtherGroupAttributes && (
                                        <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                            <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    Name
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={10} sm={8} md={8} lg={6} xl={6}>
                                                <TextField
                                                    size='small' variant="outlined"
                                                    error={ItemNameError && ItemNameError.length ? true : false}
                                                    required
                                                    helperText={ItemNameError}
                                                    fullWidth
                                                    onChange={handleChange}
                                                    value={formState.Name}
                                                    name='Name'
                                                    label='Product Name'
                                                />
                                            </Grid>
                                        </Grid>
                                    )}


                                    {visibleFinishedGoodAttributes && (

                                        <Grid>

                                            <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>

                                                <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                                    <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                        Grade
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={10} sm={8} md={8} lg={7} xl={7}>
                                                    <Autocomplete
                                                        id="dropdown_grade"
                                                        size='small'
                                                        value={selectedgrade}

                                                        onChange={handleSelectgrade}
                                                        options={dataGrade}
                                                        getOptionLabel={(option) => option.Description || ''}
                                                        renderInput={(params) => (
                                                            <TextField {...params}
                                                                label="Grade" variant="outlined"
                                                                error={GradeError && GradeError.length ? true : false}
                                                                required
                                                                helperText={GradeError} />
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                                <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                                    <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                        GSM
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>


                                                    <TextField
                                                        size='small'
                                                        variant="outlined"
                                                        error={GSMError && GSMError.length ? true : false}
                                                        required
                                                        helperText={GSMError}
                                                        fullWidth
                                                        label="GSM"
                                                        type='text'
                                                        onChange={(e) => {
                                                            // Allow only integers and limit length to 10
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value) && value.length <= 10) {
                                                                handleChange(e);
                                                            }
                                                        }}
                                                        value={formState.GSM}
                                                        name='GSM'
                                                        inputProps={{ style: { textAlign: 'right' }, maxLength: 10 }}
                                                        onKeyDown={(e) => {
                                                            // Prevent non-numeric keys, 'e', 'E', '+', '-', and '.'
                                                            if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Grid>

                                                <Grid item xs={12} sm={3.5} md={3.5} lg={1} xl={1}>
                                                    <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                        BF
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                                                    {/* <TextField size='small' variant="outlined" fullWidth defaultValue={0} label="BF" type='number' name='BF' onChange={handleChange} inputProps={{ style: { textAlign: 'right' } }} /> */}
                                                    <TextField
                                                        size='small'
                                                        variant="outlined"
                                                        fullWidth
                                                        defaultValue={0}
                                                        label="BF"
                                                        type='text'  // Use text to control input
                                                        name='BF'
                                                        onChange={(e) => {
                                                            // Allow only integers and limit length to 10
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value) && value.length <= 10) {
                                                                handleChange(e);
                                                            }
                                                        }}
                                                        inputProps={{ style: { textAlign: 'right' }, maxLength: 10 }}
                                                        onKeyDown={(e) => {
                                                            // Prevent non-numeric keys, 'e', 'E', '+', '-', and '.'
                                                            if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Grid>


                                            </Grid>


                                            <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                                <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                                    <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                        Dimension
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={6} sm={2} md={2.5} lg={2} xl={2}>
                                                    {/* <TextField
                                            error={WidthError && WidthError.length ? true : false}
                                            required
                                            helperText={WidthError}
                                            size='small' fullWidth type='number' variant="outlined" label="Width" onChange={handleChange} value={formState.WIDTH} name='WIDTH' inputProps={{ style: { textAlign: 'right' } }} /> */}

                                                    <TextField
                                                        error={WidthError && WidthError.length ? true : false}
                                                        required
                                                        helperText={WidthError}
                                                        size='small'
                                                        fullWidth
                                                        type='text'  // Use text to control input
                                                        variant="outlined"
                                                        label="Width"
                                                        onChange={(e) => {
                                                            // Allow numbers with up to 18 digits in total and up to 2 decimal places
                                                            const value = e.target.value;
                                                            const decimalPattern = /^\d{0,16}(\.\d{0,2})?$/; // 16 digits before decimal and up to 2 digits after decimal
                                                            if (decimalPattern.test(value)) {
                                                                handleChange(e);
                                                            }
                                                        }}
                                                        value={formState.WIDTH}
                                                        name='WIDTH'
                                                        inputProps={{ style: { textAlign: 'right' }, maxLength: 18 }} // maxLength includes decimal point and decimal digits
                                                        onKeyDown={(e) => {
                                                            // Prevent non-numeric keys except for '.', 'Backspace', 'Delete', 'ArrowLeft', and 'ArrowRight'
                                                            if (!/[\d.]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                                e.preventDefault();
                                                            }
                                                            // Prevent more than one '.'
                                                            if (e.key === '.' && e.target.value.includes('.')) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Grid>

                                                <Grid item xs={6} sm={0.5} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography variant="h6" fontWeight="bold">
                                                        -
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={6} sm={2} md={2.5} lg={2} xl={2}>
                                                    {/* <TextField size='small' fullWidth type='number' variant="outlined" label="Length" onChange={handleChange} value={formState.LENGTH} name='LENGTH' inputProps={{ style: { textAlign: 'right' } }} /> */}

                                                    <TextField
                                                        size='small'
                                                        fullWidth
                                                        type='text'  // Use text to control input
                                                        variant="outlined"
                                                        label="Length"
                                                        onChange={(e) => {
                                                            // Allow numbers with up to 18 digits in total and up to 2 decimal places
                                                            const value = e.target.value;
                                                            const decimalPattern = /^\d{0,16}(\.\d{0,2})?$/; // 16 digits before decimal and up to 2 digits after decimal
                                                            if (decimalPattern.test(value)) {
                                                                handleChange(e);
                                                            }
                                                        }}
                                                        value={formState.LENGTH}
                                                        name='LENGTH'
                                                        inputProps={{ style: { textAlign: 'right' }, maxLength: 18 }} // maxLength includes decimal point and decimal digits
                                                        onKeyDown={(e) => {
                                                            // Prevent non-numeric keys except for '.', 'Backspace', 'Delete', 'ArrowLeft', and 'ArrowRight'
                                                            if (!/[\d.]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                                e.preventDefault();
                                                            }
                                                            // Prevent more than one '.'
                                                            if (e.key === '.' && e.target.value.includes('.')) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Grid>

                                                <Grid item xs={6} sm={0.5} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography variant="h6" fontWeight="bold">
                                                        -
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={6} sm={2} md={2.5} lg={2} xl={2}>
                                                    {/* <TextField size='small' fullWidth type='number' variant="outlined" label="Thickness" onChange={handleChange} value={formState.thickness} name='thickness' inputProps={{ style: { textAlign: 'right' } }} /> */}

                                                    <TextField
                                                        size='small'
                                                        fullWidth
                                                        type='text'  // Use text to control input
                                                        variant="outlined"
                                                        label="Thickness"
                                                        onChange={(e) => {
                                                            // Allow numbers with up to 18 digits in total and up to 2 decimal places
                                                            const value = e.target.value;
                                                            const decimalPattern = /^\d{0,16}(\.\d{0,2})?$/; // 16 digits before decimal and up to 2 digits after decimal
                                                            if (decimalPattern.test(value)) {
                                                                handleChange(e);
                                                            }
                                                        }}
                                                        value={formState.thickness}
                                                        name='thickness'
                                                        inputProps={{ style: { textAlign: 'right' }, maxLength: 21 }} // maxLength includes decimal point and decimal digits
                                                        onKeyDown={(e) => {
                                                            // Prevent non-numeric keys except for '.', 'Backspace', 'Delete', 'ArrowLeft', and 'ArrowRight'
                                                            if (!/[\d.]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                                e.preventDefault();
                                                            }
                                                            // Prevent more than one '.'
                                                            if (e.key === '.' && e.target.value.includes('.')) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                                <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                                                    <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                        UOM
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={6} sm={1.5} md={2.5} lg={3} xl={3}>
                                                    <Autocomplete
                                                        size='small'
                                                        value={selectedunit}
                                                        onChange={handleSelectunit}
                                                        options={dataUnit}

                                                        getOptionLabel={(option) => option.Description || ''}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="UOM" variant="outlined"
                                                                error={UOMError && UOMError.length ? true : false}
                                                                required
                                                                helperText={UOMError} />


                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>

                                        </Grid>

                                    )}
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={5} xl={5}  >


                                    {/* <Card style={{ backgroundColor: theme.palette.background.default }} sx={{ borderRadius: '10px 10px 10px 10px', maxWidth: 260, textAlign: 'center' }}>
                                    {image ? (
                                        <>
                                            <CardMedia
                                                component="img"
                                                height="194"
                                                image={image}
                                                alt="Uploaded image"
                                            />
                                            <CardActions>
                                                <Button size="small" sx={{ color: 'whitesmoke' }} onClick={() => document.getElementById('image-upload-input').click()}>
                                                    Change Image
                                                </Button>
                                                <IconButton aria-label="delete" onClick={handleImageDelete}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </CardActions>
                                        </>
                                    ) : (
                                        
                                        <div
                                            style={{
                                                height: '194px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '1px dashed gray',
                                                borderRadius: '10px',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => document.getElementById('image-upload-input').click()}
                                        >
                                            <input
                                                type="file"
                                                id="image-upload-input"
                                                style={{ display: 'none' }}
                                                onChange={handleImageChange}
                                            />
                                            <IconButton >
                                                <ImageSearchIcon fontSize='large' />
                                            </IconButton>
                                           
                                            <p style={{ color: '#3380bd' }}>Browse images</p>
                                        </div>
                                    )}
                                </Card> */}

                                    <Card style={{ backgroundColor: theme.palette.background.default }} sx={{ borderRadius: '10px 10px 10px 10px', maxWidth: 260, textAlign: 'center' }}>
                                        {image ? (
                                            <>
                                                <CardMedia
                                                    component="img"
                                                    height="194"
                                                    image={image}
                                                    alt="Uploaded image"
                                                />
                                                <CardActions>
                                                    <Button size="small" sx={{ color: 'whitesmoke' }} onClick={handleClick}>
                                                        Change Image
                                                    </Button>
                                                    <IconButton aria-label="delete" onClick={handleImageDelete}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </CardActions>
                                            </>
                                        ) : (
                                            <div
                                                style={{
                                                    height: '194px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    border: '1px dashed gray',
                                                    borderRadius: '10px',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={handleClick}
                                            >
                                                <IconButton>
                                                    <ImageSearchIcon fontSize='large' />
                                                </IconButton>
                                                <p style={{ color: '#3380bd' }}>Browse images</p>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            ref={fileInputRef}
                                            onChange={handleImageChange}
                                        />
                                    </Card>
                                </Grid>
                            </Grid>

                            <Divider style={{
                                marginTop: '30px',
                                marginBottom: '10px',
                                height: '0.2px',
                            }} />

                            <Grid container spacing={0}>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} mr={2}>
                                    <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                        <Grid item xs={12} sm={3.5} md={2} lg={3.5} xl={3.5}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Unit Price
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={4} xl={6}>
                                            <TextField
                                                size='small'
                                                fullWidth
                                                type='text'  // Use text to control input
                                                variant="outlined"
                                                label="Unit Price"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const decimalPattern = /^\d{0,16}(\.\d{0,2})?$/; // 16 digits before decimal and up to 2 digits after decimal
                                                    if (decimalPattern.test(value)) {
                                                        handlePriceChange(e);
                                                    }
                                                }}
                                                value={price}
                                                name='price'
                                                inputProps={{ style: { textAlign: 'right' }, maxLength: 21 }} // maxLength includes decimal point and decimal digits
                                                onKeyDown={(e) => {
                                                    if (!/[\d.]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                        e.preventDefault();
                                                    }
                                                    if (e.key === '.' && e.target.value.includes('.')) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">{currency.Symbol}</InputAdornment>,
                                                }}
                                            />

                                        </Grid>

                                        <Grid item xs={10} sm={8} md={8} lg={2.5} xl={2.5}>



                                            <Autocomplete
                                                size='small'
                                                value={currency}
                                                onChange={handleCurrencyChange}
                                                options={data_currency}
                                                getOptionLabel={(option) => option.Description || ''}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Currency" variant="outlined"
                                                        error={CurrencyError && CurrencyError.length ? true : false}
                                                        required
                                                        helperText={CurrencyError} />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Divider style={{
                                marginTop: '20px',
                                marginBottom: '10px',
                                height: '0.2px',
                            }} />



                            <Button
                                variant='contained'
                                onClick={handleClickQRCode}
                                style={{ backgroundColor: '#1769aa', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'                                      
                                endIcon={<ExpandMoreIcon />}

                            >
                                QR Details
                            </Button>
                            {Visibleqrcode && (
                                <Grid container spacing={0}>
                                    <Grid item xs={12} sm={12} md={6} lg={12} xl={6} mr={2}>
                                        <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                            <Grid item xs={12} sm={3.5} md={2} lg={1.8} xl={3.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    QR Reference
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={10} sm={8} md={8} lg={4} xl={6}>
                                                <TextField
                                                    fullWidth
                                                    size='small'
                                                    label="QR Reference"
                                                    name="QRReference"
                                                    value={formState.QRReference}
                                                    onChange={handleChange}

                                                />
                                            </Grid>

                                            <Grid item xs={10} sm={8} md={8} lg={4} xl={2.5}>

                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    (ex: FinishedGoodInfo,RawMaterialBatch,etc)
                                                </Typography>
                                            </Grid>

                                        </Grid>

                                        <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                            <Grid item xs={12} sm={3.5} md={2} lg={1.8} xl={3.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    QR Code
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={10} sm={8} md={8} lg={4} xl={6}>
                                                <input
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    id="raised-button-file"
                                                    type="file"
                                                    onChange={handleFileChange}
                                                />
                                                <label htmlFor="raised-button-file">
                                                    <Button variant="contained" sx={{ color: 'white', textTransform: 'none' }} component="span">
                                                        Upload QR Code
                                                    </Button>
                                                </label>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
                                            <Grid item xs={12} sm={3.5} md={2} lg={1.8} xl={3.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    QR Type
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={10} sm={8} md={8} lg={4} xl={6}>
                                                <TextField
                                                    fullWidth
                                                    label="QR Type"
                                                    name="QRType"
                                                    size='small'
                                                    value={formState.QRType}
                                                    onChange={handleChange}
                                                />
                                            </Grid>

                                            <Grid item xs={10} sm={8} md={8} lg={4} xl={2.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    (ex: Product Information,Batch Number,etc)
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            )}



                        </CardContent>
                    </Box>
                    
                    <Stack>
                        <CustomSnackbar
                            open={snackbarOpen}
                            message={alertMessage}
                            onClose={handleSnackbarClose}
                            type={alertsevierity}
                        />
                    </Stack>
                </Box>
            )}

            {
                isVisible_commanButtons && (
                    <Box justifyContent={'space-between'} sx={{
                        position: 'fixed',
                        bottom: 0,
                        width: '100%'
                    }}>
                        <Divider style={{ backgroundColor: '' }} />
                        <Toolbar >
                            <Button variant='contained' style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }} onClick={handleSubmit} type="Submit">
                                Save
                            </Button>

                            <Button
                                variant='contained' onClick={ClearAll}
                                style={{ marginRight: '0px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                            >
                                Clear
                            </Button>
                        </Toolbar>
                    </Box>
                )
            }
        </Box>
    );
};

export default ProductMaster;
